export const TOUR_ABOVE_OVERLAY_Z_INDEX = '100002'
export const TOUR_WIDGET_Z_INDEX = '100001'

export function waitForElement(selector: string, timeout = 3000): Promise<Element> {
  return new Promise((resolve, reject) => {
    const el = document.querySelector(selector)
    if (el) {
      resolve(el)
      return
    }
    const observer = new MutationObserver(() => {
      const found = document.querySelector(selector)
      if (found) {
        clearTimeout(timer)
        observer.disconnect()
        resolve(found)
      }
    })
    observer.observe(document.body, { childList: true, subtree: true })
    const timer = setTimeout(() => {
      observer.disconnect()
      reject(new Error(`waitForElement timeout: ${selector}`))
    }, timeout)
  })
}
